"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _NavSearch = _interopRequireDefault(require("../NavSearch/NavSearch"));

var _ButtonClose = _interopRequireDefault(require("./ButtonClose"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    position: "absolute",
    width: "100%",
    height: theme.spacing(8),
    zIndex: 2,
    top: 0,
    right: 0,
    bottom: "auto",
    left: 0
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "bold",
    marginLeft: theme.spacing(3)
  },
  close: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: theme.spacing(1)
  },
  search: {
    display: "flex",
    position: "relative",
    backgroundColor: "inherit",
    color: "inherit",
    width: "100%",
    height: theme.spacing(8),
    overflow: "hidden",
    fontFamily: "Akkurat, sans-serif"
  }
}));

const DialogHeader = ({
  className,
  title,
  search,
  onClose
}) => {
  const classes = useStyles();
  return _react.default.createElement(_Paper.default, {
    component: "header",
    elevation: 1,
    square: true,
    className: className || classes.root
  }, title && _react.default.createElement(_Typography.default, {
    className: classes.title
  }, title), !search && _react.default.createElement(_ButtonClose.default, {
    className: classes.close,
    onClick: onClose
  }), search && _react.default.createElement(_NavSearch.default, _extends({}, search, {
    className: classes.search,
    onReset: onClose
  })));
};

DialogHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes.default.string,
  search: _propTypes.default.shape({
    placeholder: _propTypes.default.string,
    q: _propTypes.default.string,
    onChange: _propTypes.default.func
  })
} : {};
var _default = DialogHeader;
exports.default = _default;
module.exports = exports.default;